import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { initialize, reset as resetForm } from 'redux-form';
import type from './types';
import _ from 'lodash';
import { recebedorParaFormulario } from './gateway/recebedorFormulario';

const URL_UPDATE_PROFILE = `${BASE_API}/user-establishment-profile`;
const URL_SIGNUP_PAGARME = `${BASE_API}/gateway-digital-accounts`;

/** Com `campos` (validação do backend), mostra o que falta em vez do resumo. */
const mensagemDeErroDoCadastro = (dados) =>
  Array.isArray(dados?.campos) && dados.campos.length
    ? dados.campos.map((campo) => campo.mensagem).join(' ')
    : `${dados.message}`;

export const setDetail = (values) => {
  return (dispatch) => {
    dispatch({
      type: type.LIST_LOAD,
      payload: true,
    });
    const initialValues = {
      ...values,
    };
    dispatch([
      {
        type: type.ITEM_DETAIL,
        payload: { data: values },
      },
      initializeForm(initialValues),
      reset(),
    ]);
  };
};

export const getPagarmeDetail = (id, email) => {
  return (dispatch, getState) => {
    dispatch({
      type: type.PAGARME_DATA_LOAD,
      payload: true,
    });
    axios
      .get(`${URL_SIGNUP_PAGARME}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        if (!_.isArray(response.data)) {
          const emailDoUsuario =
            email ||
            (typeof getState === 'function'
              ? getState()?.auth?.user?.email
              : undefined);
          const { recebedor, formulario } = recebedorParaFormulario(
            response.data,
            { email: emailDoUsuario }
          );
          dispatch([
            {
              type: type.PAGARME_DATA_FETCHED,
              payload: { data: formulario, recebedor },
            },
            initialize('GatewayForm', formulario),
          ]);
        } else {
          dispatch({
            type: type.PAGARME_DATA_LOAD,
            payload: false,
          });
        }
      })
      .catch((e) => {
        dispatch({
          type: type.PAGARME_DATA_LOAD,
          payload: false,
        });
        // Não mostrar erro se for apenas "conta não cadastrada" - isso é esperado para novos estabelecimentos
        const errorMessage =
          e.response?.data?.error || e.response?.data?.message;
        if (
          errorMessage &&
          !errorMessage.includes('ainda não possui uma conta bancária')
        ) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `${errorMessage}`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

export const initializeForm = (values) => {
  return initialize('ProfileForm', values);
};

export const reset = () => {
  return resetForm('ProfileForm');
};

export const updateProfile = (values) => {
  return (dispatch) => {
    axios
      .post(URL_UPDATE_PROFILE, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Você atualizou a seu perfil com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
      })
      .catch((e) => {
        dispatch({
          type: 'SNACKBAR',
          payload: {
            message: `Erro ${e.response.data.messages[0]}`,
            variant: 'error',
            open: true,
          },
        });
      });
  };
};

export const saveGatewayInfo = (values) => {
  return (dispatch) => {
    axios
      .post(URL_SIGNUP_PAGARME, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Você atualizou a seu perfil com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
      })
      .catch((e) => {
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: mensagemDeErroDoCadastro(e.response.data),
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

export const putGatewayInfo = (values, id) => {
  return (dispatch) => {
    axios
      .put(`${URL_SIGNUP_PAGARME}/${id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Você atualizou a seu perfil com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
      })
      .catch((e) => {
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: mensagemDeErroDoCadastro(e.response.data),
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

// Detalhe de uma conta de link de pagamento, já no formato do formulário
export const getPaymentLinkAccountDetail = (accountId) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `${URL_SIGNUP_PAGARME}/payment-link/${accountId}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      );
      return recebedorParaFormulario(data, {
        prefixo: 'payment_link_account',
        campoSocios: 'paymentLinkManagingPartners',
      });
    } catch (e) {
      dispatch({
        type: 'SNACKBAR',
        payload: {
          message:
            e.response?.data?.message ||
            'Não foi possível carregar os dados da conta.',
          variant: 'error',
          open: true,
        },
      });
      return null;
    }
  };
};

export const savePaymentLinkGatewayInfo = (values) => {
  return (dispatch) => {
    return axios
      .post(`${URL_SIGNUP_PAGARME}/payment-link`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Informações para Link de Pagamento salvas com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
        return true;
      })
      .catch((e) => {
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: mensagemDeErroDoCadastro(e.response.data),
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
        // Falso: o formulário mantém o que foi digitado para correção.
        return false;
      });
  };
};

export const putPaymentLinkGatewayInfo = (values, id) => {
  return (dispatch) => {
    return axios
      .put(`${URL_SIGNUP_PAGARME}/payment-link/${id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Informações para Link de Pagamento atualizadas com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
        return true;
      })
      .catch((e) => {
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: mensagemDeErroDoCadastro(e.response.data),
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
        // Falso: o formulário mantém o que foi digitado para correção.
        return false;
      });
  };
};

// Buscar recebedor existente no Pagar.me pelo documento (CPF/CNPJ)
export const searchRecipientByDocument = async (document) => {
  try {
    const response = await axios.get(
      `${BASE_API}/gateway-digital-accounts/search-recipient/${document}`,
      {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    console.error('Erro ao buscar recebedor:', e);
    return { found: false };
  }
};

// Buscar contas de payment_link do usuário
export const getPaymentLinkAccounts = (establishment_id) => {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${BASE_API}/gateway-digital-accounts/payment-link-accounts/${establishment_id}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      );
      return response.data;
    } catch (e) {
      console.error('Erro ao buscar contas de payment_link:', e);
      return [];
    }
  };
};

// Deletar conta de payment_link
export const deletePaymentLinkAccount = (account_id) => {
  return async (dispatch) => {
    try {
      await axios.delete(
        `${BASE_API}/gateway-digital-accounts/payment-link/${account_id}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      );
      return true;
    } catch (e) {
      console.error('Erro ao deletar conta:', e);
      return false;
    }
  };
};
